<template>
  <div v-if="answers" id="tab-answers" class="answers">
    <div v-if="has_speech_to_text" class="video_in_txt_all" @click="toggleAll">
      <icon-txt class="video_in_txt_icon" />
      <span>{{ $tr('response.speech_to_text') }}</span>
    </div>
    <ul class="list">
      <li
        v-for="(question, index) in questions"
        :ref="'question' + index"
        :key="index"
        class="item"
        :class="{ selected: currentQuestionIndex === index, 'no-video': has_no_video(index), 'is-paused': !is_playing }"
      >
        <div class="body nanswers" v-if="!isSafari && !isIos">
          <!-- <i class="fa fa-caret-right"></i> -->
          <div class="body_icons">
            <div v-if="!has_no_video(index)" class="con_iplay" @click="play(index)">
              <icon-play
                v-if="question.video !== null && (is_current_question_paused(index) || (currentQuestionIndex !== index))"
                class="iplay"
                :fill="is_current_question_paused(index) ? '#00d26e' : '#9FAAB6'"
              />
            </div>
          </div>

          <div class="number" @click="play(index)">{{ index + 1 }}.</div>

          <div class="q-text" @click="play(index)">
            <div v-if="question.question_media">
              <span>{{ $tr('response.video_question') }}</span>

              <span v-if="question.question_media.question_video_title">.&nbsp;</span>

              <span v-html="question.question_media.question_video_title || ''"></span>
            </div>

            <div v-else v-html="question.body"></div>

            <div v-if="has_speech_to_text" class="video_in_txt_content" :class="{ disabled: !answers[index].content }">
              <div v-if="has_speech_to_text" :class="['video_in_txt', { disabled: !answers[index].content }]">
                <icon-txt class="video_in_txt_icon" @click="toggleAnswer(index)" />
              </div>

              <span v-if="answers[index].opened">{{ answers[index].content || '' }}</span>
            </div>
          </div>
        </div>

        <vrecursive-block v-else :count="questions.length - 1" :current_index="index" :handle_click="first_play_click">
          <div class="body nanswers">
            <div class="body_icons">
              <!-- <i class="fa fa-caret-right"></i> -->
              <div v-if="!has_no_video(index)" class="con_iplay" @click="play(index)">
                <icon-play
                  v-if="
                    question.video !== null && (is_current_question_paused(index) || currentQuestionIndex !== index)
                  "
                  class="iplay"
                  :fill="is_current_question_paused(index) ? '#00d26e' : '#9FAAB6'"
                />
              </div>

              <div :class="['video_in_txt', { disabled: !answers[index].content }]" v-if="has_speech_to_text">
                <icon-txt class="video_in_txt_icon" @click="toggleAnswer(index)" />
              </div>
            </div>

            <div class="number" @click="play(index)">{{ index + 1 }}.</div>

            <div class="q-text" @click="play(index)">
              <div v-if="question.question_media">
                <span>{{ $tr('response.video_question') }}</span>

                <span v-if="question.question_media.question_video_title">.&nbsp;</span>

                <span v-html="question.question_media.question_video_title || ''"></span>
              </div>

              <div v-else v-html="question.body"></div>

              <div
                v-if="has_speech_to_text"
                class="video_in_txt_content"
                :class="{ disabled: !answers[index].content }"
              >
                <span v-if="answers[index].opened">{{ answers[index].content || '' }}</span>
              </div>
            </div>
          </div>
        </vrecursive-block>
      </li>
    </ul>
  </div>
</template>

<script>
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js'

export default {
  name: 'tab-answers',

  mixins: [SafariBrowserDetector],

  props: {
    questions: Array,
    responseId: String
  },

  data() {
    return {
      settings: { maxScrollbarLength: 600, wheelSpeed: 20 },
      answers: this.answersInit(),
      playclick_count: 0
    };
  },

  computed: {
    currentQuestionIndex() {
      return this.$store.state.vacancy.videointerview.index;
    },

    is_playing() {
      return this.$store.getters['vacancy/videointerview/is_playing'];
    },

    is_video_started() {
      return this.$store.getters['interview/videointerview/is_video_started'];
    },

    vblock() {
      return this.$parent.$refs.vblock;
    },

    first_click_was() {
      return this.$store.getters['interview/videointerview/first_click_was'];
    },

    has_speech_to_text() {
      if (!this.answers || !this.answers.length) return false;

      let has_text = false;

      this.answers.forEach(answer => {
        if (answer.content) {
          has_text = true;
        }
      });

      return has_text;
    }
  },

  watch: {
    questions() {
      this.answers = this.answersInit();
    }
  },

  beforeDestroy() {
    this.$store.commit('interview/videointerview/clear');
  },

  methods: {
    changeAnalysisView(value) {
      this.answers = this.answers.map((answer, index) => {
        return {
          ...answer,
          isAnalysisShowed: index === value ? !this.answers[value].isAnalysisShowed : false
        };
      });
    },

    has_no_video(index) {
      return this.questions[index].video === null
    },

    is_current_question_paused(index) {
      if (this.currentQuestionIndex === index && !this.is_playing) {
        return true;
      } else {
        return false;
      }
    },

    answersInit() {
      return this.questions.map((answer, index) => {
        return answer.video
          ? {
              content: answer.video.text,
              opened: false
            }
          : {
              content: '',
              opened: false
            };
      });
    },

    toggleAll() {
      let state;
      let opened = this.answers.filter(i => i.opened);
      if(opened.length > 0 && opened.length === this.answers.length) {
        state = false;
      } else if(opened.length > 0) {
        state = false;
      } else {
        state = true;
      }

      this.answers.forEach(i => {
        i.opened = state
      })
    },

    toggleAnswer (index) {
      this.answers[index].opened = !this.answers[index].opened;
    },
    first_play_click (val, current_index) {
      if(this.has_no_video(val)) {
        return;
      }

      if (this.is_video_started || !this.$parent || this.first_click_was) {
        return;
      }
      let refs;
      if(this.$parent.$refs['player_' + val] === undefined) {
        // надо избавиться от этого, надеюсь в 3й задаче по видео добьюсь этого, требуется существенный рефакторинг затронет спец процессы
        refs = this.$parent.$parent.$refs.videointerview_block.$refs.process_layer.$refs;
      } else {
        refs = this.$parent.$refs;
      }
      // На iOs при первом клике на вопрос выполянется мгновенный play, затем pause и unmute всех видео вопросов.
      // Сделано, чтобы на iOs корректно отрабатывало автопереключение видео
      // if (this.isIos || this.isSafari) {
      this.playclick_count = this.playclick_count + 1;

      if(this.questions[val].video === null) {
        return;
      }
      if (val !== current_index) {
        refs['player_' + val][0].player.play();
        refs['player_' + val][0].player.pause();
      }
      refs['player_' + val][0].player.muted(false)
      refs['player_' + val][0].player.volume(1)

      // setTimeout(() => {
      refs['player_' + val][0].player.muted(false)
      refs['player_' + val][0].player.volume(1)
      if (this.playclick_count === this.questions.length - 1) {
        this.$store.commit('interview/videointerview/set_first_click_was', true);
      }

      if (this.playclick_count >= this.questions.length) {
        this.$store.commit('interview/videointerview/toggle_start_video', true);
      }
      // }, 100)
      // }
    },
    /*
    setAnswer (index) {
      this.$store.commit('vacancy/videointerview/setIndex', index)
    },
    */
    play (index) {
      if(this.questions[index].video === null) {
        if (this.isIos || this.isSafari) {
          this.$emit('set_active_answer', index);
        }
        this.$store.commit('vacancy/videointerview/setIndex', index)
        return;
      }

      if (this.isIos || this.isSafari) {
        this.$emit('set_active_answer', index);
        this.$store.commit('vacancy/videointerview/set_playing', !this.is_playing)
      } else {
        this.$store.commit('vacancy/videointerview/set_playing', index !== this.currentQuestionIndex)
      }
      this.$store.commit('vacancy/videointerview/setAutoPlay', true)
      this.$store.commit('vacancy/videointerview/setIndex', index)

    }
  }
};
</script>

<style lang="scss" scoped>
.video_in_txt_all {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.005em;
  color: #607183;
  margin-top: -3px;
  user-select: none;
  cursor: pointer;
  span {
    padding-left: 10px;
  }
}
.video_in_txt {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0px;
  left: -40px;
  user-select: none;
  .video_in_txt_icon {
    cursor: pointer;
  }

  &.disabled {
    opacity: 0.7;
    cursor: not-allowed;

    .video_in_txt_icon {
      cursor: not-allowed;
    }
  }
}
.video_in_txt_content {
  position: relative;
  margin-left: -11px;
  min-height: 20px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  margin-top: 14px;
  color: #607183;
  font-style: italic;
  font-size: 15px;
  letter-spacing: 0.005em;
}

.scroll-container {
  position: relative;
  max-height: 610px;
}

.answers {
  .list {
    list-style-type: none;
    margin-top: 10px;
    margin-right: 5px;
    padding: 0;

    .item {
      border-bottom: 1px solid $trable-row-border-color;
      padding: 15px 0 15px 0;
      position: relative;

      .body {
        display: flex;

        .number {
          font-size: 15px;
          line-height: 22px;
          letter-spacing: 0.005em;
        }

        .q-text {
          padding-left: 4px;
          font-size: 15px;
          line-height: 22px;
          letter-spacing: 0.005em;
          color: #233346;

          ::v-deep p {
            margin: 0;
            font-size: 15px;
            letter-spacing: 0.4px;
          }
        }

        i {
          cursor: pointer;
          color: $green;
          position: absolute;
          top: 16px;
          left: 0;
          font-size: 18px;
          visibility: hidden;

          width: 25px;
          height: 25px;
          border: 1px solid $white-color;
          border-radius: 25px;
          text-align: center;
          line-height: 24px;
          box-sizing: border-box;
          padding-left: 3px;
        }
      }
      &.selected:not(.is-paused) {
        .con_iplay {
          background: url('/static/icons/pause.svg') center no-repeat;
        }
      }
      &.selected .body {
        i {
          visibility: visible;
        }
      }

      &.no-video {
        color: #bfc5cc;

        &.selected {
          color: #9faab6;
        }
      }

      &:not(.selected):hover .body {
        i {
          visibility: visible;
          color: $text-dark-color;
          border-color: $input-light-border-color;
        }
      }

      &:hover .body {
        i {
          &:hover {
            color: $green;
            border-color: $green;
          }
        }
      }

      .body {
        cursor: pointer;

        &:hover {
          color: $green-hover;

          .q-text {
            color: $green-hover;
          }
        }
      }

      .toggle-answer {
        display: flex;
        cursor: pointer;
        align-items: center;

        &:hover {
          color: $green-hover;
        }

        i {
          font-size: 10px;
          margin-left: 5px;
        }
      }

      .toggle-answer,
      .answer {
        color: $text-dark-color;
        padding-top: 10px;
        margin-left: 20px;
      }
    }
  }
}
.nanswers {
  .con_iplay {
    margin-right: 15px;
    margin-top: 2px;
    cursor: pointer;
    width: 13px;
    height: 16px;
    min-width: 13px;
    min-height: 16px;
  }
}
.noty-msg {
  margin-top: 7px;
  line-height: 22px;
  font-size: 15px;
  letter-spacing: 0.005em;

  color: #607183;
}

.body_icons {
  display: flex;
  flex-direction: column;
  min-width: 28px;
  margin-right: 7px;
  margin-top: 2px;
}
</style>
